import apiClient from "services/apiClient";

async function createConversation(id:any) {
  const url = `/admin/conversations`;
  const res = await apiClient.post(url, id);
  return res.data;
}

export default createConversation;
